import { combineReducers } from "@reduxjs/toolkit";
import mainReducer from "./scenes/Main/main.slice";
import carnetsReducer from "./scenes/Carnets/carnets.slice";

const rootReducer = combineReducers({
  main: mainReducer,
  carnets: carnetsReducer,
});

export default rootReducer;
